import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import { getPosts } from '../lib/api';

function QueLeer() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPosts()
      .then((data) => setPosts(data.posts))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page">
      <Seo title="Qué leer" description="Recomendaciones de lectura: qué leer en cada época, por género o por temática." />
      <h1>Qué leer</h1>
      <p className="page__intro">
        Contenido editorial evergreen: libros para leer en otoño, mejores thrillers para empezar, libros parecidos
        a…, novelas cortas, libros para regalar.
      </p>

      {!loading && posts.length === 0 && (
        <p className="empty-state">Todavía no hay artículos publicados en esta sección.</p>
      )}
      <div className="card-grid">
        {posts.map((post) => (
          <Link key={post.id} to={`/que-leer/${post.slug}`} className="content-card">
            {post.cover_url && <img src={post.cover_url} alt={post.title} />}
            <div className="content-card__body">
              <h3 className="content-card__title">{post.title}</h3>
              {post.excerpt && <p className="content-card__excerpt">{post.excerpt}</p>}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default QueLeer;
